import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('tel/list', { params });
  },
  async add(params: any) {
    return axios.post('tel/add', qs.stringify(params));
  },
  async logs(params: any) {
    return axios.get('tel/logs', { params })
  },
  async soundRecordingUrl(params: any) {
    return axios.get('tel/sound-recording-url', { params })
  }
};
